import type { MailboxInfo } from 'owa-client-types';
import getAccountBySourceId from '../selectors/getAccountBySourceId';
import { accountRankTypeChecker } from '../store/schema/AccountSourceList';
import setCoprincipalAdditionalProps from './setCoprincipalAdditionalProps';

export default function setMsaLinkedMailboxInfo(
    sourceId: string,
    msaMailboxInfo: MailboxInfo | undefined
): void {
    const accountSource = getAccountBySourceId(sourceId);

    if (accountRankTypeChecker.isCoprincipal(accountSource)) {
        setCoprincipalAdditionalProps(sourceId, {
            msaLinkedMailbox: msaMailboxInfo,
        });
    }
}
